import React, { useEffect, useRef } from 'react';
import { sponsors } from '../mockData';

const Sponsors = () => {
  const scrollRef1 = useRef(null);

  useEffect(() => {
    const scroll1 = scrollRef1.current;
    if (!scroll1) return;

    let pos1 = 0;

    const animate = () => {
      pos1 += 0.5;
      if (pos1 >= scroll1.scrollWidth / 2) pos1 = 0;
      scroll1.scrollLeft = pos1;
      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  // Duplicate only twice for seamless loop
  const duplicatedSponsors = [...sponsors, ...sponsors];

  return (
    <section className="bg-black text-white py-16 sm:py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 mb-10 sm:mb-12 md:mb-16">
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-center">
          OUR <span className="font-light">PARTNERS</span>
        </h2>
      </div>

      <div className="space-y-6 sm:space-y-8">
        {/* Single Row - Scroll Right */}
        <div ref={scrollRef1} className="overflow-x-hidden px-4 sm:px-6">
          <div className="flex gap-4 sm:gap-6 md:gap-8 lg:gap-12 items-center">
            {duplicatedSponsors.map((sponsor, index) => (
              <div
                key={`sponsor-${index}`}
                className="flex-shrink-0 w-32 sm:w-40 md:w-48 h-16 sm:h-20 md:h-24 flex items-center justify-center bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 transition-colors duration-300 p-2 sm:p-3 md:p-4"
              >
                <img
                  src={sponsor.logo}
                  alt={sponsor.name}
                  className={`max-w-full max-h-full object-contain ${sponsor.id === 8 ? 'invert' : ''} ${sponsor.id === 5 ? 'scale-[1.55]' : ''}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;